import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function Counter({
  from,
  to,
  suffix = ''
}: {
  from: number;
  to: number;
  suffix?: string;
}) {
  const [count, setCount] = useState(from);
  const nodeRef = useRef<HTMLSpanElement>(null);
  const inView = useInView(nodeRef, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (inView) {
      let startTime: number;
      const duration = 2000; // 2 seconds
      const animate = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = (timestamp - startTime) / duration;
        if (progress < 1) {
          const easeProgress = 1 - Math.pow(2, -10 * progress);
          setCount(Math.floor(from + (to - from) * easeProgress));
          requestAnimationFrame(animate);
        } else {
          setCount(to);
        }
      };
      requestAnimationFrame(animate);
    }
  }, [inView, from, to]);
  return <span ref={nodeRef} data-id="element-670">
      {count}
      {suffix}
    </span>;
}
const stats = [{
  value: 1500,
  suffix: '+',
  label: 'Properties Delivered'
}, {
  value: 3000,
  suffix: '+',
  label: 'Happy Clients'
}, {
  value: 10,
  suffix: '+',
  label: 'Years Experience'
}, {
  value: 15,
  suffix: '+',
  label: 'Cities Covered'
}];
export function Stats() {
  return <section className="py-24 px-6 md:px-12 max-w-[1280px] mx-auto bg-bone" data-id="element-671">
      <div className="border-y border-ink/10 py-16" data-id="element-672">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-0 md:divide-x divide-ink/10" data-id="element-673">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center text-center px-4" data-id="element-674">
              <div className="text-4xl md:text-6xl font-serif text-ink mb-2" data-id="element-675">
                <Counter from={0} to={stat.value} suffix={stat.suffix} data-id="element-676" />
              </div>
              <div className="text-sm text-ink/60 font-medium" data-id="element-677">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}